export enum BrandType {
    TexasCapitalBank = 1,
    BaskBank = 2,
    PrivateWealth = 3
  }
